import type { CaptureConsent } from './ClipsApi'
import type { CaptureConsentPort, CaptureConsentRequestOptions } from './CaptureConsentPort'

/**
 * PlaygroundHost impl: the web playground has no native harness — the browser shows the
 * real getUserMedia prompt itself, so app-consent is treated as granted.
 */
export class BrowserCaptureConsent implements CaptureConsentPort {
  async get(): Promise<CaptureConsent> {
    return { status: 'granted', canAskAgain: true }
  }

  async request(_opts?: CaptureConsentRequestOptions): Promise<CaptureConsent> {
    return { status: 'granted', canAskAgain: true }
  }

  async set(status: 'granted' | 'denied'): Promise<CaptureConsent> {
    return { status, canAskAgain: status !== 'denied' }
  }
}
